import { useQuery } from "@tanstack/react-query";
import {
  AllowedValuesDTO,
  getAllowedValues,
} from "api";
import { QUERY_KEYS } from "consts";

export const useGetAllowedValues = () =>
  useQuery<AllowedValuesDTO>([QUERY_KEYS.ALLOWED_VALUES], getAllowedValues);
